export const GAMESCONFIG = {
  SESSION_AMOUNT: 3,
};
